import { Box, BoxProps, Group, Title } from '@mantine/core';
import { useParams } from 'react-router-dom';
import { useQuery } from '@apollo/client';
import { GET_TRIP_PROFILE } from '@queries/trip-profiles';
import LoadingData from './graphql-loading-data';
import classes from './title-bar.module.css';

interface TitleBarProps extends BoxProps {
  textClassName?: string;
  order?: 1 | 2 | 3 | 4 | 5 | 6;
  textStyle?: React.CSSProperties;
  fluid?: boolean; // when false, render inline for compact overlays
}

function TitleBar({ textClassName, order = 2, textStyle, fluid = true, ...boxProps }: TitleBarProps) {
  const { tripProfileId = '' } = useParams();

  const { loading, error, data } = useQuery(GET_TRIP_PROFILE, {
    variables: {
      id: tripProfileId,
    },
    skip: !tripProfileId,
  });
  if (!tripProfileId) return null;
  if (loading) return <LoadingData />;
  if (error) return null;

  return (
    <Box
      className={classes.headerBar}
      style={{ display: fluid ? undefined : 'inline-block', width: fluid ? undefined : 'auto' }}
      {...boxProps}
    >
      <Group className="flex-row" justify="space-between">
        <Title order={order} className={`${classes.headerBarText} ${textClassName ?? ''}`} style={textStyle}>
          Trip: {data?.singleTripProfile.title}
        </Title>
        <Title order={order} className={`${classes.headerBarText} ${textClassName ?? ''}`} style={textStyle}>
          {data?.singleTripProfile.destination
            ? `Destination: ${data?.singleTripProfile.destination}, ${data?.singleTripProfile.country}`
            : 'No Destination Saved'}
        </Title>
      </Group>
    </Box>
  );
}

export default TitleBar;
